import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';
import type { AysClinicsFilter } from '@bindoc-projects/clinics-filter-domain-lib';
import type { AysClinicContainer } from '@bindoc-projects/clinic-domain-lib';

/** Application-supplied condition lookup used by clinic selection imports. */
export interface ClinicConditionReader {
  result(filter: AysClinicsFilter, year?: number): Observable<AysClinicContainer[]>;
}

export const CLINIC_CONDITION_READER = new InjectionToken<ClinicConditionReader>(
  'CLINIC_CONDITION_READER',
);
